import { namespace } from "@core/contants/constant";
import table from "@store/reducers/pattern/table";

export const name = `${namespace}_season`;

export default table(name);
